module.exports = __webpack_public_path__ + "static/media/back-arrow.1d5691ad.svg";